import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { CompetitionBlacklist } from './competition-blacklist'
import { CompetitionBlacklistSerializer } from './competition-blacklist.serializer'

@Injectable()
export class CompetitionBlacklistService extends ResourceService<CompetitionBlacklist> {
  constructor(
    private http: HttpClient,
    private competitionBlacklistSerializer: CompetitionBlacklistSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/competition-black-list`,
      competitionBlacklistSerializer
    )
  }
}
